const ALLOWED_FILE_TYPES = [
    'image/bmp',
    'image/gif',
    'image/jpeg',
    'image/png',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
];

const ALLOWED_EXT = '.bmp,.gif,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf';

const SELECT_OPTION = {
    en: 'Select One',
    es: 'Seleccione uno',
};

const MAX_FILE_SIZE_IN_MB = 5;

export const VERIFICATION = {
    NOT_VERIFIED_TEXT_ACTION_NEEDED: 'dmi.applicantVerifications.actionNeeded',
    NOT_VERIFIED_TEXT: 'dmi.applicantVerifications.notVerifiedLabel',
    VERIFIED_TEXT: 'dmi.applicantVerifications.verified',
    STARTS_WITH: '--',
    ALLOWED_FILE_TYPES,
    ALLOWED_EXT,
    SUCCESS: 'SUCCESS',
    ZERO_DOLLARS: '$0',
    INCOME: 'Income',
    AMOUNT_INPUT_MIN_VALUE: -999000000,
    AMOUNT_INPUT_MAX_VALUE: 999000000,
    SELECT_OPTION,
    MAX_FILE_SIZE_IN_MB,
    ROP_EXPIRED: 'ROP_EXPIRED',
};

export const VERIFICATION_TYPE = {
    DEATH: 'Death',
    NON_ESI_MINIMUM_ESSENTIAL_COVERAGE: 'Non-ESI Minimum Essential Coverage',
};
